import EmoneyUsers from './EmoneyUsers';

export default EmoneyUsers;



// WEBPACK FOOTER //
// ./src/views/emoney/index.js